/*
 *
 * LanguageProvider constants
 *
 */
export const REDUCER_KEY = 'LanguageProvider';
export const CHANGE_LOCALE = 'app/LanguageProvider/CHANGE_LOCALE';
